import { useEffect, useState } from "react";

/**
 * How the rail is shown (docs/design/v3-handoff/README.md "Responsive"):
 * - full: the 256px rail, at 960px and wider;
 * - mini: a 72px icon rail while an Ask Polyfuture conversation is open, at 760px and wider;
 * - drawer: hidden behind a menu button, below those widths.
 */
export type RailMode = "full" | "mini" | "drawer";

export function railModeFor(width: number, conversationOpen: boolean): RailMode {
  if (conversationOpen) return width >= 760 ? "mini" : "drawer";
  return width >= 960 ? "full" : "drawer";
}

/**
 * The element's width, measured with ResizeObserver; the viewport width until it is measured.
 * It takes the element rather than a ref because the shell mounts only after sign-in.
 */
export function useElementWidth(element: HTMLElement | null): number {
  const [width, setWidth] = useState(() =>
    typeof window === "undefined" ? 1280 : window.innerWidth,
  );
  useEffect(() => {
    if (element === null || typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry !== undefined) setWidth(entry.contentRect.width);
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);
  return width;
}
